import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  CurrencyType,
  PaymentProvider,
  PaymentType,
  TotalPayment,
} from 'interfaces/payment';

export interface IPaymentState {
  paymentType: PaymentType;
  paymentProvider: PaymentProvider;
  paymentCurrency: CurrencyType;
  stripeIsComplete: boolean;
  couponCode: string;
  termsAndConditions: boolean;
  privacyPolicy: boolean;
  paymentErrors: {
    isTermsAndConditionsValid: boolean;
    isPrivacyPolicyValid: boolean;
  };
  totalPayment: TotalPayment;
}

const initialState: IPaymentState = {
  paymentType: 'card',
  paymentProvider: 'revolut',
  paymentCurrency: 'HUF',
  stripeIsComplete: false,
  couponCode: '',
  termsAndConditions: false,
  privacyPolicy: false,
  paymentErrors: {
    isTermsAndConditionsValid: true,
    isPrivacyPolicyValid: true,
  },
  totalPayment: {
    serviceFee: 0,
    totalPayment: 0,
  },
};

const payment = createSlice({
  name: 'payment',
  initialState,
  reducers: {
    setPaymentCurrency: (state, action: PayloadAction<CurrencyType>) => {
      state.paymentCurrency = action.payload;
    },
    setPaymentMethod: (state, action: PayloadAction<PaymentType>) => {
      state.paymentType = action.payload;
    },
    setPaymentProvider: (state, action: PayloadAction<PaymentProvider>) => {
      state.paymentProvider = action.payload;
    },
    setStripeIsComplete: (state, action: PayloadAction<boolean>) => {
      state.stripeIsComplete = action.payload;
    },
    setCouponCode: (state, action: PayloadAction<string>) => {
      state.couponCode = action.payload;
    },
    setTermsAndConditions: (state, action: PayloadAction<boolean>) => {
      state.termsAndConditions = action.payload;
    },
    setPrivacyPolicy: (state, action: PayloadAction<boolean>) => {
      state.privacyPolicy = action.payload;
    },
    setIsTermsAndConditionsValid: (state, action: PayloadAction<boolean>) => {
      state.paymentErrors.isTermsAndConditionsValid = action.payload;
    },
    setIsPrivacyPolicyValid: (state, action: PayloadAction<boolean>) => {
      state.paymentErrors.isPrivacyPolicyValid = action.payload;
    },
    setTotalPayment: (state, action: PayloadAction<TotalPayment>) => {
      state.totalPayment = action.payload;
    },
  },
});

export const { actions } = payment;

export default payment.reducer;
